import { Divider, Grid, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useEffect, useState } from "react";

const InvoiceInfoHeader = ({ invoice, onClickRef }) => {
  const { openSuccess, openError } = usePopupNotificationContext();
  const [invoiceData] = useState(invoice); // This is to avoid "undefined" when closing the modal
  const [searchableRefs, setSearchableRefs] = useState([]);
  const onCopyClick = (e, value) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(value)
      .then(() => {
        openSuccess("Kopierat!", 3000);
      })
      .catch(() => {
        openError("Failed to copy", 3000);
      });
  };

  useEffect(() => {
    if (invoiceData) {
      const tmpSearchableRefs = invoiceData.Comment?.replace(";", " ").split(
        " "
      );
      setSearchableRefs(tmpSearchableRefs ? tmpSearchableRefs : []);
    }
  }, [invoiceData]);

  return (
    <Grid
      item
      container
      color="rgba(0, 0, 0, 0.6)"
      m={"20px 20px 0px 20px"}
      justifyContent={"center"}
    >
      <Grid item>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            cursor: onClickRef ? "pointer" : null,
          }}
          onClick={() => (onClickRef ? onClickRef(invoiceData?.OCR) : null)}
        >
          <Typography
            textAlign="left"
            fontWeight="bold"
          >{`${invoiceData?.OCR}`}</Typography>
          <ContentCopyIcon
            fontSize="small"
            sx={{ cursor: "pointer" }}
            onClick={(e) => onCopyClick(e, invoiceData?.OCR)}
          />
        </div>
      </Grid>
      <Grid item mx={1}>
        <Divider orientation="vertical" />
      </Grid>
      <Grid
        item
        onClick={() =>
          onClickRef ? onClickRef(invoiceData?.EndCustomerName) : null
        }
        sx={{ cursor: onClickRef ? "pointer" : null }}
      >
        <Typography textAlign="left" fontWeight="bold">{`${
          invoiceData?.EndCustomerName || ""
        }`}</Typography>
      </Grid>
      <Grid item mx={1}>
        <Divider orientation="vertical" />
      </Grid>
      <Grid
        item
        onClick={() => (onClickRef ? onClickRef(invoiceData?.Amount) : null)}
        sx={{ cursor: onClickRef ? "pointer" : null }}
      >
        <Typography textAlign="left" fontWeight="bold">{`${
          invoiceData?.Amount || 0
        } :-`}</Typography>
      </Grid>
      {Number(invoiceData?.AmountLeft) !== Number(invoiceData?.Amount) ? (
        <>
          <Grid item mx={1}>
            <Divider orientation="vertical" />
          </Grid>
          <Grid item>
            <Typography textAlign="left" fontWeight="bold">
              <span
                onClick={() =>
                  onClickRef ? onClickRef(invoiceData?.AmountLeft) : null
                }
                style={{ cursor: onClickRef ? "pointer" : null }}
              >
                {invoiceData?.AmountLeft ?? 0}
              </span>
              {" av "}
              <span
                onClick={() =>
                  onClickRef ? onClickRef(invoiceData?.Amount) : null
                }
                style={{ cursor: onClickRef ? "pointer" : null }}
              >
                {`${invoiceData?.Amount ?? 0} :-`}
              </span>
            </Typography>
          </Grid>
        </>
      ) : null}
      <Grid item container justifyContent={"center"}>
        {searchableRefs.map((ref) => (
          <Grid
            item
            mx={0.5}
            key={ref}
            onClick={() => (onClickRef ? onClickRef(ref) : null)}
            sx={{ cursor: onClickRef ? "pointer" : null }}
          >
            <Typography textAlign="left">{ref}</Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default InvoiceInfoHeader;
